export const capitalizeName = (name:string): string => {
    return name?.replace(/\b\w/g, c => c.toUpperCase());
};

// Formats a card expiration as MM/YY (zero-padded month, 2-digit year)
export const formatCardExpiry = (month: number, year: number): string => {
    return `${String(month).padStart(2, '0')}/${String(year).slice(-2)}`;
};